
import { DashboardLayout } from "@/components/ui/glassmorphism-sidebar";

export default function DemoOne() {
    return (
        <div className="App w-full h-full min-h-screen">
            <DashboardLayout />
        </div>
    );
}
